import React from "react";
import { Heading } from "../../../Heading";
import { GatsbyImageOrSvg } from "../../../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";
import { IComparisonCard } from "../../../../types/IComparisonCard";
import { RichText } from "../../../RichText";

import "./styles.scss";

interface IProsAndConsV2PanelProps {
  comparisonCards: IComparisonCard[];
}

export const ProsAndConsV2Panel = ({ comparisonCards }: IProsAndConsV2PanelProps) => (
  <div
    role="region"
    aria-label="Comparison panel"
    className="prosConsPanel"
  >
    {comparisonCards.map((card, index) => (
      <div key={`${card.title}-${index}`} className="prosConsPanel__card">
        <Heading className="prosConsPanel__cardTitle">
          {card.title}
        </Heading>
        <div className="prosConsPanel__itemContainer">
          {card.items.map((item, index) => (
            <div className="prosConsPanel__item" key={`${item.title}-${index}`}>
              {item.image && <GatsbyImageOrSvg image={item.image} alt={item.image.altText || `${item.image.title}-icon`} loading="lazy" />}
              <div>
                <p className={item.content ? "prosConsPanel__title" : undefined}>{item.title}</p>
                {item.content && (
                  <RichText
                    className="prosConsPanel__content"
                    content={item.content}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
